import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { FlexLayoutModule } from '@angular/flex-layout';

import { FuseDirectivesModule } from '@fuse/directives/directives';
import { FusePipesModule } from '@fuse/pipes/pipes.module';
import { AspRegDecPopupComponent } from 'app/asp-reg-dec-popup/asp-reg-dec-popup.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';


@NgModule({
     declarations: [
        AspRegDecPopupComponent
    ],
    imports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        // FlexLayoutModule,

        FuseDirectivesModule,
        FusePipesModule,
        MatIconModule,
        MatButtonModule
    ],
    exports  : [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,

        FlexLayoutModule,

        FuseDirectivesModule,
        FusePipesModule,
        AspRegDecPopupComponent
    ]
})
export class FuseSharedModule
{
}
